import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from 'app/auth/auth.service';
import { CustomerTaskService } from 'app/selfcare/tasks/customertask.service';
import { MitIdService } from 'app/utils/mitId/mit-id.service';
import { NavigationService } from 'app/utils/navigation/navigation.service';
import { QueryParametersService } from 'app/utils/queryParameters/query-parameters.service';

@Component({
    selector: 'mit-id-landing',
    templateUrl: './mit-id-landing.component.html',
    styleUrls: ['./mit-id-landing.component.less'],
})
export class MitIdLandingComponent implements OnInit {
    failedGetTasksAttempts = 0;
    requireSsn = false;
    customerNotFound = false;

    constructor(
        private customerTaskService: CustomerTaskService,
        private router: Router,
        private navService: NavigationService,
        private authService: AuthService,
        private route: ActivatedRoute,
        private mitIdService: MitIdService,
        private queryParametersService: QueryParametersService
    ) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe((params: Params) => {
            const state = params['state'];
            const code = params['code'];

            if (state && code) {
                this.authService
                    .token('useridentity', `state=${state}&code=${code}`)
                    .then(
                        () => {
                            const redirectUrl = this.mitIdService.getSuccessRedirectUrl();

                            if (redirectUrl) {
                                this.router.navigateByUrl(redirectUrl);
                            } else {
                                this.redirectToSelfcare();
                            }
                        },
                        (error) => {
                            const redirectUrl = this.mitIdService.getFailRedirectUrl();

                            if (error?.error?.error) {
                                let url = redirectUrl ?? this.navService.getUrl('selfcare-login');

                                // Remove existing error
                                if (this.queryParametersService.getQueryVariable('mitIdError')) {
                                    url = this.queryParametersService.removeQueryVariable('mitIdError', url);
                                }

                                const errorPrefix = url.indexOf('?') === -1 ? '?' : '&';

                                url += errorPrefix + 'mitIdError=' + encodeURIComponent(error.error.error);

                                this.router.navigateByUrl(url);
                            } else if (redirectUrl) {
                                this.router.navigateByUrl(redirectUrl);
                            } else {
                                this.redirectToSelfcareLogin();
                            }
                        }
                    )
                    .finally(() => {
                        this.mitIdService.clearRedirectUrls();
                    });
            } else {
                this.redirectToSelfcareLogin();
                this.mitIdService.clearRedirectUrls();
            }
        });
    }

    redirectToPage(page: string) {
        const url = this.navService.getUrl(page);
        this.router.navigateByUrl(url);
    }

    redirectToSelfcareLogin() {
        this.redirectToPage('selfcare-login');
    }

    redirectToSelfcare() {
        this.customerTaskService
            .getTasks()
            .toPromise()
            .then(
                (tasks) => {
                    const urlKey = tasks.length > 0 ? 'selfcare-tasks' : 'selfcare-overview';

                    const url = this.navService.getUrl(urlKey);

                    this.router.navigateByUrl(url);
                },
                () => {
                    this.failedGetTasksAttempts += 1;

                    if (this.failedGetTasksAttempts >= 3) {
                        const url = this.navService.getUrl('selfcare-overview');

                        this.router.navigateByUrl(url);
                        return;
                    }

                    this.authService.refreshToken().then(() => {
                        this.redirectToSelfcare(); // try again
                    });
                }
            );
    }
}
